module.exports = __webpack_public_path__ + "static/fast-50-0d6e2f3896984e343cafa9f1a129044d.svg";